@if (access.premiumModalOpen()) {
  <div
    class="premium-modal__backdrop"
    (click)="onBackdropClick($event)"
    aria-hidden="true"></div>
  <div
    class="premium-modal__dialog"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="'premium-modal-title'"
    [attr.aria-describedby]="'premium-modal-desc'"
    (animationend)="onDialogAnimationEnd()">
    <h2 id="premium-modal-title" class="premium-modal__title">
      {{ 'premiumAssistant.title' | translate }}
    </h2>
    <p id="premium-modal-desc" class="premium-modal__body">
      {{ 'premiumAssistant.body' | translate }}
    </p>
    <button type="button" class="premium-modal__ok" (click)="close()">
      {{ 'premiumAssistant.ok' | translate }}
    </button>
  </div>
}
